import { useState } from 'react';
import type { Service, Staff } from '@salonomy/types';
import { Button, Field, Modal, Select, TextInput } from '@salonomy/ui';
import { useJoinQueue } from '../../data/queue.js';
import { useToast } from '../../lib/toast.js';

export function JoinQueueModal({
  staff,
  services,
  onClose,
}: {
  staff: Staff[];
  services: Service[];
  onClose: () => void;
}) {
  const join = useJoinQueue();
  const toast = useToast();
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [serviceId, setServiceId] = useState('');
  const [staffId, setStaffId] = useState('');

  const chairs = staff.filter(
    (s) => s.active && ['owner', 'stylist', 'chair_renter'].includes(s.role),
  );

  function submit() {
    if (!name.trim()) {
      toast.error('Add a name for the ticket.');
      return;
    }
    join.mutate({
      clientName: name.trim(),
      phone: phone.trim() ? phone.trim() : null,
      serviceId: serviceId || null,
      requestedStaffId: staffId || null,
      notifyLeadMin: 10,
    });
    onClose();
  }

  return (
    <Modal
      open
      onClose={onClose}
      title="Add to the queue"
      width={420}
      footer={
        <>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={submit}>Add ticket</Button>
        </>
      }
    >
      <Field label="Name">
        <TextInput
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Walk-in name"
        />
      </Field>
      <Field label="Mobile" hint="Optional — so we can text their place + ETA">
        <TextInput
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="+44 7700 900123"
          inputMode="tel"
        />
      </Field>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
        <Field label="Service">
          <Select value={serviceId} onChange={(e) => setServiceId(e.target.value)}>
            <option value="">Any</option>
            {services
              .filter((s) => s.active)
              .map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
          </Select>
        </Field>
        <Field label="With">
          <Select value={staffId} onChange={(e) => setStaffId(e.target.value)}>
            <option value="">Any chair</option>
            {chairs.map((s) => (
              <option key={s.id} value={s.id}>
                {s.displayName}
              </option>
            ))}
          </Select>
        </Field>
      </div>
    </Modal>
  );
}
